<template>
  <ul class="kt-menu__nav">
    <h5 style="margin-left: 20px; font-size: 1.15em;">Services</h5>
    <li class="mt-1 kt-menu__item" :class="[currentPage.includes(service.slug + '/') ? 'kt-menu__item--active' : '']"
        v-for="(service, index) in services" :key="index" aria-haspopup="true">
      <a href="#" @click.prevent="setSelectedService(service)" class="kt-menu__link">
        <span class="kt-menu__link-icon">
          <i :class="service.menu_icon"></i>
        </span>
        <span class="kt-menu__link-text">{{ service.title }}</span>
      </a>
    </li>
  </ul>
</template>

<script>
import ServicesMenuMixin from "@/mixins/servicesMenu.js";

export default {
  name: "Menu",
  mixins: [ServicesMenuMixin],
};
</script>
